import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ParametersModule} from '@catmodules/models/parameters/parameters.module';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';
import {ModifyNetworkIfComponent} from "@catmodules/models/network-interfaces/components/modify-network-if/modify-network-if.component";
import {NetworkInterfaceService} from "@catmodules/models/network-interfaces/services/network-interface.service";
import { NetworkIfListComponent } from "@catmodules/models/network-interfaces/components/network-if-list/network-if-list.component";
import {FeatureNetworkInterfaceService} from "@catmodules/models/network-interfaces/services/feature-network-interface.service";

const publicComponents = [
  ModifyNetworkIfComponent,
  NetworkIfListComponent
];

const imports = [
  CommonModule,
  FormsModule,
  UIBaseModule,
  UIFormModule,
  ReactiveFormsModule,
  ParametersModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [
  NetworkInterfaceService,
  FeatureNetworkInterfaceService,
];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class NetworkInterfacesModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/network-interfaces/network-interfaces.module.ts